import {
	Button,
	Flex,
	notification,
	Typography,
	Checkbox,
	Statistic,
	Table,
} from "antd";
import React, { useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import dayjs from "dayjs";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import { getAggregateCogsCost } from "../utils/CogCost";

const { Text } = Typography;

const jobStatusOptions = [
	{ value: "Trouble", label: "Trouble" },
	{ value: "ok", label: "Poured" },
	{ value: "Confirm", label: "A/R Confirmed" },
	{ value: "Operations done (AR)", label: "Operations done (AR)" },
	{
		value: "Scheduled",
		label: "Scheduled",
	},
	{ value: "Inactive", label: "Inactive" },
	{ value: "Company cancellation", label: "Company cancellation" },
	{ value: "Customer cancellation", label: "Customer cancellation" },
	{ value: "Date moved", label: "Date moved" },
	{ value: "Active", label: "Pouring" },
	{ value: "Ready to Load", label: "Ready to be scheduled" },
	{ value: "Quote", label: "Quote" },
	{ value: "Waiting Inspection", label: "Waiting Inspection" },
];

const columns = [
	{
		title: "Job ID",
		dataIndex: "number",
		key: "number",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Customer",
		dataIndex: "customer",
		key: "customer",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Customer PO Number",
		dataIndex: "customerPONumber",
		key: "customerPONumber",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Seller",
		dataIndex: "seller",
		key: "seller",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Foreman",
		dataIndex: "foremanName",
		key: "foremanName",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Foreman Phone",
		dataIndex: "foremanPhone",
		key: "foremanPhone",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Relocated",
		dataIndex: "plantChanged",
		key: "plantChanged",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "Subplant",
		dataIndex: "subplant",
		key: "subplant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Date Time",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Address",
		dataIndex: "shipAddress",
		key: "shipAddress",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Load",
		dataIndex: "loadYD3",
		key: "loadYD3",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Target",
		dataIndex: "targetYD3",
		key: "targetYD3",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Rate (CY/HR)",
		dataIndex: "rate",
		key: "rate",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "On Time",
		dataIndex: "performanceOnTime",
		key: "performanceOnTime",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "Dest. Time",
		dataIndex: "destinationTime",
		key: "destinationTime",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Dest. Milles",
		dataIndex: "distance",
		key: "distance",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "PSI",
		dataIndex: "psi",
		key: "psi",
		render: (value) => {
			return <Text>{value}</Text>;
		},
		width: 500,
	},
	{
		title: "Slump",
		dataIndex: "slump",
		key: "slump",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Fiber",
		dataIndex: "fiber",
		key: "fiber",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "Cogs",
		dataIndex: "cogs",
		key: "cogs",
		render: (value) => {
			return (
				<Statistic
					value={value}
					precision={2}
					valueStyle={{
						fontSize: 14,
					}}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Sold Price",
		dataIndex: "unitPrice",
		key: "unitPrice",
		render: (value) => {
			return (
				<Statistic
					value={value}
					precision={2}
					valueStyle={{
						fontSize: 14,
					}}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Gross",
		dataIndex: "gross",
		key: "gross",
		render: (value) => {
			return (
				<Statistic
					value={value}
					precision={2}
					valueStyle={{
						fontSize: 14,
					}}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Approved Price",
		dataIndex: "approvedPrice",
		key: "approvedPrice",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "QB Price",
		dataIndex: "qbPrice",
		key: "qbPrice",
		render: (value) => {
			return (
				<Statistic
					value={value}
					precision={2}
					valueStyle={{
						fontSize: 14,
					}}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Factored Invoice",
		dataIndex: "factoredInvoice",
		key: "factoredInvoice",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},

	{
		title: "Minimum Price",
		dataIndex: "minPrice",
		key: "minPrice",
		render: (value) => {
			return (
				<Statistic
					value={value}
					precision={2}
					valueStyle={{
						fontSize: 14,
					}}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Maximum Price",
		dataIndex: "maxPrice",
		key: "maxPrice",
		render: (value) => {
			return (
				<Statistic
					value={value}
					precision={2}
					valueStyle={{
						fontSize: 14,
					}}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Pour/Type",
		dataIndex: "pourType",
		key: "pourType",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Status",
		dataIndex: "jobStatus",
		key: "jobStatus",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Scheduled Date",
		dataIndex: "scheduledDate",
		key: "scheduledDate",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Check In",
		dataIndex: "measurement",
		key: "measurement",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "Ice Surcharge",
		dataIndex: "iceSurcharge",
		key: "iceSurcharge",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "Light Surcharge",
		dataIndex: "lightSurcharge",
		key: "lightSurcharge",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "Pour",
		dataIndex: "pour",
		key: "pour",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "QA/QC",
		dataIndex: "qualityControl",
		key: "qualityControl",
		render: (value) => {
			return <Checkbox checked={value} />;
		},
	},
	{
		title: "Priority",
		dataIndex: "priority",
		key: "priority",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Comments",
		dataIndex: "comments",
		key: "comments",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const columns2 = [
	{
		title: "Load",
		dataIndex: "loadId",
		key: "loadId",
		render: (value, record) => {
			return <Text strong>{value}</Text>;
		},
	},
	{
		title: "Truck",
		dataIndex: "truck",
		key: "truck",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Loaded",
		dataIndex: "loaded",
		key: "loaded",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "To Job",
		dataIndex: "toJob",
		key: "toJob",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Arrive Job",
		dataIndex: "arriveJob",
		key: "arriveJob",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Start Unload",
		dataIndex: "startUnload",
		key: "startUnload",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Start Unload",
		dataIndex: "finishUnload",
		key: "finishUnload",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const EXPANDABLE_JOB_STATUSES = ["Poured", "Operations done (AR)"];

const DownloadDailyByJobStatus = ({ onSuccess }) => {
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [plants, setPlants] = useState([]);
	const [plant, setPlant] = useState(undefined);
	const [jobStatus, setJobStatus] = useState(undefined);
	const [data, setData] = useState([]);

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getPlants();
	}, []);

	useEffect(() => {
		if (startDate && endDate && plant && jobStatus) {
			getJobs();
		} else {
			setData([]);
		}
	}, [startDate, endDate, plant, jobStatus]);

	const refactorJobStatus = (jobStatus) => {
		let status = jobStatus;
		if (status === "ok") {
			status = "Poured";
		} else if (status === "Confirm") {
			status = "A/R Confirmed";
		} else if (status === "Active") {
			status = "Pouring";
		} else if (status === "Ready to Load") {
			status = "Ready to be scheduled";
		}
		return status;
	};
	const sanitize = (val) =>
		typeof val === "string" ? val.replace(/"/g, "'") : val || "NA";

	const getJobs = async () => {
		setLoading(true);
		const start = `${startDate.year()}-${startDate.month() + 1}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;
		const url =
			api +
			`/job/get/byplant/bystatus?startDate=${start}&endDate=${end}&plant=${plant}&jobStatus=${jobStatus}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				const newRows = data.payload.map((dato) => {
					let customer = "NA";
					if (dato.customer !== null) {
						customer = dato.customer.customerNumber + " " + dato.customer.name;
					}

					let seller = "NA";
					if (dato.seller !== null) {
						seller = dato.seller.name;
					}

					const cogsPrice = getAggregateCogsCost(dato.aggregate);

					return {
						number: dato.number,
						customer,
						customerPONUmber: dato.customerPONumber || "NA",
						seller,
						plantChanged: dato.plantChanged || false,
						subplant: dato.subplant || "NA",
						date: `${new Date(dato.scheduledDate).toLocaleDateString()} - ${new Date(
							dato.scheduledDate,
						).toLocaleTimeString([], {
							timeStyle: "short",
						})}`,
						shipAddress: dato.customerShipAddress
							? dato.customerShipAddress + " - " + dato.shipAddress
							: dato.shipAddress,
						loadYD3: dato.loadYD3,
						targetYD3: `${dato.targetYD3} + ${dato.balance}`,
						rate: dato.deliveryRate,
						performanceOnTime: dato.performanceOnTime || false,
						destinationTime: dato.destinationTime
							? dato.destinationTime
							: dato.destinationMinutes,
						distance: dato.distance,
						psi: sanitize(dato.psiId ? dato.psiId.psi : dato.psi),
						slump: dato.slump,
						fiber: dato.fiberQuantity && dato.fiberQuantity > 0,
						cogs: cogsPrice.toFixed(2),
						unitPrice: dato.unitPrice,
						gross: (dato.unitPrice - cogsPrice).toFixed(2),
						approvedPrice: dato.approvedPrice || false,
						qbPrice: dato.qbPrice || 0,
						factoredInvoice: dato.factoredInvoice || false,
						minPrice: dato.psiId
							? dato.psiId.minPrice
								? dato.psiId.minPrice
								: 0
							: 0,
						maxPrice: dato.psiId
							? dato.psiId.price
								? dato.psiId.price
								: 0
							: 0,
						pourType: dato.jobPoor + " / " + dato.jobType,
						jobStatus: refactorJobStatus(dato.jobStatus),
						scheduledDate: dato.readyToBeScheduledDate
							? `${new Date(
									dato.readyToBeScheduledDate,
								).toLocaleDateString()} - ${new Date(
									dato.readyToBeScheduledDate,
								).toLocaleTimeString([], { timeStyle: "short" })}`
							: "-",

						measurement: dato.measurement || false,
						iceSurcharge:
							dato.iceSurcharge && dato.iceSurcharge !== 0 ? true : false,
						lightSurcharge:
							dato.lightSurcharge && dato.lightSurcharge !== 0 ? true : false,
						pour: dato.pourYards || false,
						qualityControl: dato.qualityControl || false,
						priority: dato.priority || "Low",
						comments: dato.comments,
						loads: dato.loads
							? dato.loads.map((item) => ({
									key: item._id,
									toJob: item.toJobDate
										? dayjs(item.toJobDate)
												.add(5, "hour")
												.format("MM/DD/YYYY HH:mm A")
										: "-",
									arriveJob: item.toArriveDate
										? dayjs(item.toArriveDate)
												.add(5, "hour")
												.format("MM/DD/YYYY HH:mm A")
										: "-",
									startUnload: item.startUnloadDate
										? dayjs(item.startUnloadDate)
												.add(5, "hour")
												.format("MM/DD/YYYY HH:mm A")
										: "-",
									finishUnload: item.finishUnloadDate
										? dayjs(item.finishUnloadDate)
												.add(5, "hour")
												.format("MM/DD/YYYY HH:mm A")
										: "-",
									loaded: dayjs(item.date).format("MM/DD/YYYY HH:mm A"),
									loadId: item.deliveryTicket,
									truck: item.truckNumber,
								}))
							: [],
						foremanName: dato.foreman
							? `${dato.foreman.firstName} ${dato.foreman.lastName}`
							: "NA",
						foremanPhone: dato.foreman ? dato.foreman.phone || "-" : "-",
					};
				});
				setData(newRows);
				setLoading(false);
			} else {
				setLoading(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/plant/list/57Concrete`;

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				let list = [{ value: "All", label: "All" }];
				data.payload
					.filter((item) => item.name !== "Laredo")
					.map((item) => {
						list.push({
							value: item._id,
							label: item.name,
						});
					});
				setPlants(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", "Cannot get plants");
			return null;
		}
	};

	const exportExcel = () => {
		if (!data || data.length === 0) {
			openNotification("error", "Error", "No hay datos para descargar");
			return;
		}

		const rows = [];

		// Encabezado principal, usa los mismos títulos que la tabla de jobs
		rows.push(columns.map((col) => col.title));

		data.forEach((job) => {
			rows.push(columns.map((col) => job[col.dataIndex]));

			if (EXPANDABLE_JOB_STATUSES.includes(job.jobStatus)) {
				rows.push([]);

				rows.push(columns2.map((col) => col.title));

				(job.loads || []).forEach((load) => {
					rows.push(columns2.map((col) => load[col.dataIndex]));
				});

				rows.push([]);
			}
		});

		const ws = XLSX.utils.aoa_to_sheet(rows);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Daily Report");

		const selectedPlant = plants.find((item) => item.value === plant);
		const plantName = selectedPlant ? selectedPlant.label : "All";

		const start = `${startDate.year()}-${startDate.month() + 1}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const fileName = `57concrete-daily-report-${plantName}-${start}_${end}.xlsx`;

		XLSX.writeFile(wb, fileName);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const CustomForm = () => {
		return (
			<Flex vertical gap={10}>
				<CustomSearch
					dateFormat={"MM/DD/YYYY"}
					startDate={startDate}
					endDate={endDate}
					onRangeChange={onRangeChange}
					allowClearDate={false}
					labelPicker={"plant"}
					optionsPicker={plants}
					onChangePicker={(v) => setPlant(v)}
					pickerValue={plant}
					allowClearPicker={true}
					labelPicker2={"job status"}
					optionsPicker2={jobStatusOptions}
					onChangePicker2={(v) => setJobStatus(v)}
					pickerValue2={jobStatus}
					allowClearPicker2={true}
				/>

				<Button
					size="large"
					type="primary"
					style={{ width: "170px" }}
					onClick={exportExcel}
					loading={loading}
				>
					Download Report
				</Button>
			</Flex>
		);
	};

	const RenderTable = () => {
		return (
			<Table
				columns={columns}
				dataSource={data}
				pagination={{
					position: ["bottomRight"],
					pageSizeOptions: [10, 20, 50, 100, 250, 500],
					defaultPageSize: 10,
					showSizeChanger: true,
				}}
				scroll={{
					x: true,
				}}
				style={{
					minWidth: "100%",
				}}
				loading={loading}
				rowKey="number"
				expandable={{
					rowExpandable: (record) =>
						EXPANDABLE_JOB_STATUSES.includes(record.jobStatus),
					expandedRowRender: (record) => (
						<CustomTable
							columns={columns2}
							data={record.loads}
							isScroll={false}
							rowKey="key"
						/>
					),
				}}
			/>
		);
	};

	return (
		<>
			{contextHolder}
			<CustomForm />
			{loading ? <CustomSpinner /> : <RenderTable />}
		</>
	);
};

export default DownloadDailyByJobStatus;
